import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from 'app/services/app.service';
import {SakuraModelService} from 'app/core/sakuraModel.service';
import {Pagination} from '../entities/pagination.entity';
import {plainToInstance} from 'class-transformer';
import {ListModelService} from '../core/list.interface';
import {Shift} from '../entities/shift.entity';

@Injectable({
  providedIn: 'root'
})
export class ShiftModelService extends SakuraModelService implements ListModelService {

  currentShift: Shift = null;
  lastShifts: Shift[] = [];

  notificationActive = false;

  constructor(
    http: HttpClient,
    appService: AppService
  ) {
    super(http, appService);
  }

  getShifts(
    page = 1,
    callback: (shifts: Shift[], pagination: Pagination) => void) {

    this.get({
      page,
    }, 'shifts-pwa/shifts', (response) => {
      if (response.status) {
        const shifts = plainToInstance(Shift, response.result.items) as unknown as Shift[];

        if (page === 1) {
          this.lastShifts = shifts;
        }

        callback(shifts, response.pagination);
      } else {
        // if (response.message) {
        //   this.appService.showToast(response.message, 'danger');
        // }

        callback(null, null);
      }
    }, false, true);
  }

  getCurrentShift(callback: (result: boolean) => void) {
    this.get({}, 'shifts-pwa/current-shift', (response) => {
      if (response.status && response.result.item) {
        this.currentShift = plainToInstance(Shift, response.result.item);

      } else {
        this.currentShift = null;
      }

      callback(response.status);
    }, false, true);
  }

  getEmptyShift(callback: (shift: Shift) => void) {

    this.get({}, 'shifts-pwa/create', (response) => {
      if (response.status) {

        response.result.item.settings = response.result.settings;

        callback(
          plainToInstance(Shift, response.result.item) as unknown as Shift
        );
      } else {
        callback(null);
      }
    }, false, true);
  }

  createShift(shift: Shift, callback: (shift: Shift) => void) {

    this.post(shift, {}, 'shifts-pwa/create', (response) => {
      if (response.status) {
        callback(
          plainToInstance(Shift, response.result.item) as unknown as Shift
        );
      } else {
        if (response.message) {
          this.appService.showToast(response.message, 'danger');
        }

        callback(null);
      }
    }, false);
  }

  updateShift(shift: Shift, callback: (shift: Shift) => void) {

    this.post(shift, {}, 'shifts-pwa/update', (response) => {
      if (response.status) {
        callback(
          plainToInstance(Shift, response.result.item) as unknown as Shift
        );
      } else {
        if (response.message) {
          this.appService.showToast(response.message, 'danger');
        }

        callback(null);
      }
    }, false);
  }

  deleteShift(shift: Shift, callback: (status: boolean) => void) {

    this.delete({id: shift.id}, {}, 'shifts-pwa/delete', (response) => {
      if (response.status) {
        callback(true);
      } else {
        if (response.message) {
          this.appService.showToast(response.message, 'danger');
        }

        callback(false);
      }
    });
  }

  getItems(
    page: number = 1,
    filters: any,
    callback: (fines: Shift[], pagination: Pagination) => void
  ) {
    this.getShifts(page, (items, pagination) => {
      callback(items, pagination);
    });
  }

}
